import { Layout, Error } from '@percent/product-nomination-form/ui'
import { i18n } from '@percent/product-nomination-form/i18n/config'

export const ErrorFallback = () => {
  const { t } = i18n
  return (
    <Layout>
      <Error
        title={t('grantsNominationForm.errorMessage.somethingWentWrong')}
        subtitle={t('grantsNominationForm.errorMessage.reloadPage')}
        variant={Error.variants.INTERNAL}
      />
    </Layout>
  )
}
